<template>
  <el-card>
    <el-tag type="danger">{{$t('guestID.unknownOrder')}}</el-tag>
  </el-card>
</template>

<script>
export default {
  name: 'UnknownOrder',
  data () {
    return {}
  },
}
</script>

<style scoped>
</style>
